export const access_token = 'X-Access-Token';
export const user_info = 'Open_Info';
export const tenant_id = 'tenant_id';
